module.exports = __webpack_public_path__ + "img/shop_front_1.05b4b4fd.jpg";